// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/loading.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/icons/play.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/icons/pause.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/icons/cc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/icons/cc_hidden.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/icons/fullscreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/icons/fullscreen_exit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/icons/next.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/icons/prev.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/icons/volume.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/icons/mute.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AVPlayerElement {
    display: none;
    margin: 0;
    width: 100%;
    max-height: 60vh;
    background: #f1f3f4;
    box-sizing: border-box;
}

#AVPlayerElement.video {
    display: block;
    border-radius: 27px 27px 0 0;
    border: 3px solid #f1f3f4;
}

.isLoading {
    content: '';
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
    background-size: 100px 100px;
    border-radius: 25px 25px 0 0;
}

.isLoading[is-loading='yes'] {
    display: block;
}

#mediaPlayerContainer {
    width: 100%;
    background: #f1f3f4;
    border-radius: 27px;
    position: relative;
}

#mediaPlayerContainer.video {
    border-radius: 0 0 27px 27px;
}

#imageAndSoundCaptionContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    transition: all 0.1s ease-in-out;
    padding: 10px 10px 0 10px;
    font-size: 18px;
}

#imageAndSoundCaptionContainer.hidden {
    display: none;
}

#currentCaptionContainer {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    transition: all 0.1s ease-in-out;
    padding: 10px 10px 0 10px;
    min-height: 40px;
    font-size: 18px;
}

#currentCaptionContainer.hidden {
    display: none;
}

#currentCaptionContainer>#mediaPlayerCCContainer {
    flex: 1 1;
    padding: 0 60px;
    display: flex;
    flex-direction: column;
}

#mediaPlayerCCContainer>label:first-child,
#mediaPlayerCCContainer>label:last-child {
    opacity: 0.5;
}

#mediaPlayer {
    width: 100%;
    height: 54px;
    display: flex;
}

#mediaPlayerMatches {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 10px;
}

#mediaPlayerMatches>label {
    font-size: 12px;
    margin-bottom: -9px;
}

#mediaPlayerNextPrevMatch {
    display: flex;
}

#mediaPlayerNextPrevMatch .mediaPlayerButton {
    height: 25px;
    width: 25px;
}

.mediaPlayerButtonContainer {
    padding: 10px 0;
}

.mediaPlayerButtonContainer:first-of-type {
    padding-left: 10px;
}

.mediaPlayerButtonContainer:nth-of-type(3) {
    padding-right: 10px;
}

.mediaPlayerButtonContainer:hover>div {
    background-color: #e6e7e9;
    cursor: pointer;
}

.mediaPlayerButton {
    width: 34px;
    height: 34px;
    border-radius: 17px;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px;
    transition: all 0.2s cubic-bezier(0.55, 0, 0.43, 0.9);
}

#mediaPlayerPlay {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

#mediaPlayerPlay.pause {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

#mediaPlayerCC {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

#mediaPlayerCC.hidden {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

#mediaPlayerFullscreen {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

:fullscreen #mediaPlayerFullscreen {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

#mediaPlayerNextMatch {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

#mediaPlayerPrevMatch {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

#mediaPlayerTimestamp {
    font-size: 14px;
    margin: 10px 0;
    padding: 8px 0;
}

#mediaPlayerProgressBarContainer {
    flex: 1 1;
    width: 0;
    transition: all 0.4s cubic-bezier(0.55, 0, 0.43, 0.9);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 15px;
}

#mediaPlayerProgressBar {
    height: 4px;
    border-radius: 4px;
    width: 100%;
    background: #545456;
    position: relative;
    display: flex;
    align-items: center;
    overflow-y: visible;
}

#mediaPlayerProgressBarFilled {
    height: 4px;
    border-radius: 4px;
    width: 0;
    background: #545456;
}

#mediaPlayerProgressBarSeek {
    position: absolute;
    margin-left: -5px;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background: black;
    z-index: 999;
    opacity: 1;
    transition: opacity 0.2s cubic-bezier(0.55, 0, 0.43, 0.9);
}

#mediaPlayerProgressBarContainer:hover {
    cursor: pointer;
}

#mediaPlayerProgressBarContainer:hover #mediaPlayerProgressBarSeek {
    opacity: 1;
}

#mediaPlayerProgressBar {
    height: 4px;
    background: #c1c2c4;
    border-radius: 4px;
    width: 100%;
}

#mediaPlayerVolumeContainer {
    padding: 10px 10px 10px 0;
}

#mediaPlayerVolume {
    border-radius: 17px;
    background-color: transparent;
    display: flex;
    justify-content: flex-end;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.55, 0, 0.43, 0.9);
}

#mediaPlayerVolumeIcon {
    width: 34px;
    height: 34px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px;
}

#mediaPlayerVolumeIcon.muted {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

#mediaPlayerVolumeBarContainer {
    width: 0;
    height: 34px;
    transition: all 0.4s cubic-bezier(0.55, 0, 0.43, 0.9);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 0;
}

#mediaPlayerVolumeBar {
    height: 4px;
    border-radius: 4px;
    width: 100%;
    background: #c1c2c4;
    position: relative;
    display: flex;
    align-items: center;
}

#mediaPlayerVolumeBarFilled {
    height: 4px;
    border-radius: 4px;
    width: 0;
    background: #545456;
}

#mediaPlayerVolumeBarSeek {
    width: 10px;
    height: 10px;
    margin-left: -5px;
    left: 0;
    border-radius: 10px;
    background: black;
    opacity: 1;
    transition: opacity 0.2s cubic-bezier(0.55, 0, 0.43, 0.9);
}

#mediaPlayerVolumeContainer:hover #mediaPlayerVolumeBarSeek {
    opacity: 1;
}

#mediaPlayerVolumeContainer:hover>div {
    background-color: #e6e7e9;
    cursor: pointer;
}

#mediaPlayerVolumeContainer:hover #mediaPlayerVolumeBarContainer {
    width: 75px;
    padding-left: 15px;
}

.mediaHighlight {
    background: #1faeff;
    height: 20px;
    min-width: 5px;
    position: absolute;
    z-index: 1;
}

.mediaHighlight::after {
    content: '';
    display: none;
    position: absolute;
    width: 1px;
    height: 50px;
    background: black;
    left: calc(50% - 1px);
}

.mediaHighlight::before {
    content: attr(data-tag);
    display: none;
    position: absolute;
    padding: 5px 10px;
    border-radius: 15px;
    align-items: center;
    background: black;
    font-size: 14px;
    color: white;
    top: 50px;
    margin-left: 5px;
    transform: translateX(-50%);
}

.mediaHighlight:hover::after,
.mediaHighlight:hover::before {
    display: flex;
}

#AVPlayerElement.video:hover::after {
    content: 'fullscreen';
    display: block;
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: #fff;
    color: #000;
}

#AVFileContainer {
    width: 100%;
}

.recordingVerticalLayout.video #AVFileContainer {
    position: fixed;
    left: 0;
    top: 75px;
    width: 50%;
    height: calc(100vh - 75px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.recordingVerticalLayout.video #AVFileContainer:fullscreen {
    width: 100vw;
    height: 100vh;
    top: 0;
}

#AVFileContainer:fullscreen #AVPlayerElement.video {
    margin-left: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
}

#AVFileContainer:fullscreen #mediaPlayerContainer.video {
    margin-left: 0;
    border-radius: 0;
    filter: invert();
}`, "",{"version":3,"sources":["webpack://./src/Magor/EditTranscript/AVFile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uFAAmF;IACnF,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;IACI,yDAAkD;AACtD;;AAEA;IACI,yDAAmD;AACvD;;AAEA;IACI,yDAAgD;AACpD;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;IACI,yDAAwD;AAC5D;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAAkD;AACtD;;AAEA;IACI,yDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,QAAQ;IACR,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,yDAAyD;AAC7D;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAoD;IACpD,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,0DAAkD;AACtD;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,OAAO;IACP,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,yDAAyD;AAC7D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,OAAO;IACP,SAAS;IACT,UAAU;IACV,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,MAAM;AACV;;AAEA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":["#AVPlayerElement {\n    display: none;\n    margin: 0;\n    width: 100%;\n    max-height: 60vh;\n    background: #f1f3f4;\n    box-sizing: border-box;\n}\n\n#AVPlayerElement.video {\n    display: block;\n    border-radius: 27px 27px 0 0;\n    border: 3px solid #f1f3f4;\n}\n\n.isLoading {\n    content: '';\n    display: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5) url(../../assets/icons/loading.svg) center no-repeat;\n    background-size: 100px 100px;\n    border-radius: 25px 25px 0 0;\n}\n\n.isLoading[is-loading='yes'] {\n    display: block;\n}\n\n#mediaPlayerContainer {\n    width: 100%;\n    background: #f1f3f4;\n    border-radius: 27px;\n    position: relative;\n}\n\n#mediaPlayerContainer.video {\n    border-radius: 0 0 27px 27px;\n}\n\n#imageAndSoundCaptionContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    transition: all 0.1s ease-in-out;\n    padding: 10px 10px 0 10px;\n    font-size: 18px;\n}\n\n#imageAndSoundCaptionContainer.hidden {\n    display: none;\n}\n\n#currentCaptionContainer {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    text-align: center;\n    transition: all 0.1s ease-in-out;\n    padding: 10px 10px 0 10px;\n    min-height: 40px;\n    font-size: 18px;\n}\n\n#currentCaptionContainer.hidden {\n    display: none;\n}\n\n#currentCaptionContainer>#mediaPlayerCCContainer {\n    flex: 1;\n    padding: 0 60px;\n    display: flex;\n    flex-direction: column;\n}\n\n#mediaPlayerCCContainer>label:first-child,\n#mediaPlayerCCContainer>label:last-child {\n    opacity: 0.5;\n}\n\n#mediaPlayer {\n    width: 100%;\n    height: 54px;\n    display: flex;\n}\n\n#mediaPlayerMatches {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    top: 10px;\n}\n\n#mediaPlayerMatches>label {\n    font-size: 12px;\n    margin-bottom: -9px;\n}\n\n#mediaPlayerNextPrevMatch {\n    display: flex;\n}\n\n#mediaPlayerNextPrevMatch .mediaPlayerButton {\n    height: 25px;\n    width: 25px;\n}\n\n.mediaPlayerButtonContainer {\n    padding: 10px 0;\n}\n\n.mediaPlayerButtonContainer:first-of-type {\n    padding-left: 10px;\n}\n\n.mediaPlayerButtonContainer:nth-of-type(3) {\n    padding-right: 10px;\n}\n\n.mediaPlayerButtonContainer:hover>div {\n    background-color: #e6e7e9;\n    cursor: pointer;\n}\n\n.mediaPlayerButton {\n    width: 34px;\n    height: 34px;\n    border-radius: 17px;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px;\n    transition: all 0.2s cubic-bezier(0.55, 0, 0.43, 0.9);\n}\n\n#mediaPlayerPlay {\n    background-image: url(../../assets/icons/play.svg);\n}\n\n#mediaPlayerPlay.pause {\n    background-image: url(../../assets/icons/pause.svg);\n}\n\n#mediaPlayerCC {\n    background-image: url(../../assets/icons/cc.svg);\n}\n\n#mediaPlayerCC.hidden {\n    background-image: url(../../assets/icons/cc_hidden.svg);\n}\n\n#mediaPlayerFullscreen {\n    background-image: url(../../assets/icons/fullscreen.svg);\n}\n\n:fullscreen #mediaPlayerFullscreen {\n    background-image: url(../../assets/icons/fullscreen_exit.svg);\n}\n\n#mediaPlayerNextMatch {\n    background-image: url(../../assets/icons/next.svg);\n}\n\n#mediaPlayerPrevMatch {\n    background-image: url(../../assets/icons/prev.svg);\n}\n\n#mediaPlayerTimestamp {\n    font-size: 14px;\n    margin: 10px 0;\n    padding: 8px 0;\n}\n\n#mediaPlayerProgressBarContainer {\n    flex: 1;\n    width: 0;\n    transition: all 0.4s cubic-bezier(0.55, 0, 0.43, 0.9);\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 10px 15px;\n}\n\n#mediaPlayerProgressBar {\n    height: 4px;\n    border-radius: 4px;\n    width: 100%;\n    background: #545456;\n    position: relative;\n    display: flex;\n    align-items: center;\n    overflow-y: visible;\n}\n\n#mediaPlayerProgressBarFilled {\n    height: 4px;\n    border-radius: 4px;\n    width: 0;\n    background: #545456;\n}\n\n#mediaPlayerProgressBarSeek {\n    position: absolute;\n    margin-left: -5px;\n    width: 10px;\n    height: 10px;\n    border-radius: 10px;\n    background: black;\n    z-index: 999;\n    opacity: 1;\n    transition: opacity 0.2s cubic-bezier(0.55, 0, 0.43, 0.9);\n}\n\n#mediaPlayerProgressBarContainer:hover {\n    cursor: pointer;\n}\n\n#mediaPlayerProgressBarContainer:hover #mediaPlayerProgressBarSeek {\n    opacity: 1;\n}\n\n#mediaPlayerProgressBar {\n    height: 4px;\n    background: #c1c2c4;\n    border-radius: 4px;\n    width: 100%;\n}\n\n#mediaPlayerVolumeContainer {\n    padding: 10px 10px 10px 0;\n}\n\n#mediaPlayerVolume {\n    border-radius: 17px;\n    background-color: transparent;\n    display: flex;\n    justify-content: flex-end;\n    overflow: hidden;\n    transition: all 0.4s cubic-bezier(0.55, 0, 0.43, 0.9);\n}\n\n#mediaPlayerVolumeIcon {\n    width: 34px;\n    height: 34px;\n    background-image: url(../../assets/icons/volume.svg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px;\n}\n\n#mediaPlayerVolumeIcon.muted {\n    background-image: url(../../assets/icons/mute.svg);\n}\n\n#mediaPlayerVolumeBarContainer {\n    width: 0;\n    height: 34px;\n    transition: all 0.4s cubic-bezier(0.55, 0, 0.43, 0.9);\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding-left: 0;\n}\n\n#mediaPlayerVolumeBar {\n    height: 4px;\n    border-radius: 4px;\n    width: 100%;\n    background: #c1c2c4;\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n#mediaPlayerVolumeBarFilled {\n    height: 4px;\n    border-radius: 4px;\n    width: 0;\n    background: #545456;\n}\n\n#mediaPlayerVolumeBarSeek {\n    width: 10px;\n    height: 10px;\n    margin-left: -5px;\n    left: 0;\n    border-radius: 10px;\n    background: black;\n    opacity: 1;\n    transition: opacity 0.2s cubic-bezier(0.55, 0, 0.43, 0.9);\n}\n\n#mediaPlayerVolumeContainer:hover #mediaPlayerVolumeBarSeek {\n    opacity: 1;\n}\n\n#mediaPlayerVolumeContainer:hover>div {\n    background-color: #e6e7e9;\n    cursor: pointer;\n}\n\n#mediaPlayerVolumeContainer:hover #mediaPlayerVolumeBarContainer {\n    width: 75px;\n    padding-left: 15px;\n}\n\n.mediaHighlight {\n    background: #1faeff;\n    height: 20px;\n    min-width: 5px;\n    position: absolute;\n    z-index: 1;\n}\n\n.mediaHighlight::after {\n    content: '';\n    display: none;\n    position: absolute;\n    width: 1px;\n    height: 50px;\n    background: black;\n    left: calc(50% - 1px);\n}\n\n.mediaHighlight::before {\n    content: attr(data-tag);\n    display: none;\n    position: absolute;\n    padding: 5px 10px;\n    border-radius: 15px;\n    align-items: center;\n    background: black;\n    font-size: 14px;\n    color: white;\n    top: 50px;\n    margin-left: 5px;\n    transform: translateX(-50%);\n}\n\n.mediaHighlight:hover::after,\n.mediaHighlight:hover::before {\n    display: flex;\n}\n\n#AVPlayerElement.video:hover::after {\n    content: 'fullscreen';\n    display: block;\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    background: #fff;\n    color: #000;\n}\n\n#AVFileContainer {\n    width: 100%;\n}\n\n.recordingVerticalLayout.video #AVFileContainer {\n    position: fixed;\n    left: 0;\n    top: 75px;\n    width: 50%;\n    height: calc(100vh - 75px);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.recordingVerticalLayout.video #AVFileContainer:fullscreen {\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n}\n\n#AVFileContainer:fullscreen #AVPlayerElement.video {\n    margin-left: 0;\n    border: 0;\n    border-radius: 0;\n    background: transparent;\n}\n\n#AVFileContainer:fullscreen #mediaPlayerContainer.video {\n    margin-left: 0;\n    border-radius: 0;\n    filter: invert();\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
